import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Sizing } from 'src/app/lib/sizing';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends MainService {

	product: any = null;
	customPrice: any = null;

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router,
		public sanitizer: DomSanitizer
	) {
		super(http, toastService, storage, router);
	}

	/**
	 * make an API call to get the product by SKU
	 */
	getProductBySku(sku){
		return new Promise(res => {
			this.storage.get(sku).then(product => {
				if(product){
					res(product);
				} else {
					let url = '/rest/entrelable/V1/products/' + sku;
					this.get(url).subscribe(result => {
						this.storage.setLocal(sku, result, Sizing.productStorageExp);
						res(result);
					}, error => {
						res(null);
						this.errorHandler(error);
					});
				}
			});
		});
	}
	/**
	 * retrieve the image link of the product
	 */
	getProductImage(id: any, width: any = 150, height: any = 150){
		let storageKey = 'pi' + id + width + height;
		return new Promise(res => {
			this.storage.get(storageKey).then(productImage => {
				if(productImage){
					res(productImage);
				} else {
					let url = "/rest/entrelable/V1/lns-api/product-images/" + id;
					let jsonData = [{"width": width, "height": height}];
					this.post(url, jsonData).subscribe(images => {
						res(images);
						this.storage.setLocal(storageKey, images, Sizing.productStorageExp);
					}, error => {
						res(null);
						this.errorHandler(error);
					});
				}
			});
		});
	}

	/**
	 * get custom price from magento entrelabel config
	 */
	getCustomPrice(){
		return new Promise(res => {
			if(this.customPrice){
				res(this.customPrice);
			} else {
				let url = '/rest/entrelable/V1/lns-entrelabel/config/pricing';
				this.get(url).subscribe(result => {
					res(result);
				}, error => {
					res(null);
					this.errorHandler(error);
				});
			}
		});
	}

	/**
	 * make an API call to get the product by SKU
	 */
	// getParentProductByChildId(productId: any = null){
	// 	return new Promise(res => {
	// 		this.get('/rest/entrelable/V1/lns-api/configurable-parent-sku/' + productId)
	// 		.subscribe(result => {
	// 			let r = result[0];
	// 		}, error => {
	// 			res(null);
	// 			this.errorHandler(error);
	// 		});
	// 	});
	// }


	/**
	 * retrieve the value of custom attr
	 */
	getCustomAttr(searchKey: string = '', product){
		let searchValue: any = '';
		if(product.custom_attributes){
			let ca = product.custom_attributes;

			ca.forEach((val, key) => {
				if(val.attribute_code == searchKey){
					searchValue = val.value;
					return searchValue;
				}
			});
		}
		return searchValue;
	}
}
